import { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { LoadingSpinner } from '../../ui/loadingSpinner';
import messages from './PaymentMethodAuthenticationModal.messages';
import styles from './PaymentMethodAuthenticationModal.module.css';
import classNames from 'classnames';

export class PaymentMethodAuthenticationModal extends Component<{
    authenticationIframeURL: string;
}> {
    state = { authenticationIframeLoaded: false };

    checkAuthenticationIframeLoaded = () => {
        this.setState({ authenticationIframeLoaded: true });
    };

    render() {
        const { authenticationIframeURL } = this.props;
        const iframeLoadedStyles = this.state.authenticationIframeLoaded
            ? styles.authenticationIframeLoaded
            : null;
        const iframeStyles = classNames(
            styles.authenticationIframe,
            iframeLoadedStyles
        );

        return (
            <>
                <div className={styles.title}>
                    <FormattedMessage
                        {...messages.requiresAuthenticationTitle}
                    />
                </div>
                {!this.state.authenticationIframeLoaded && (
                    <LoadingSpinner
                        className={styles.authenticationIframeLoadingSpinner}
                    />
                )}
                <iframe
                    title="authentication"
                    className={iframeStyles}
                    src={authenticationIframeURL}
                    onLoad={this.checkAuthenticationIframeLoaded}
                />
            </>
        );
    }
}
